import P5MazeGame from '/src/games/P5MazeGame';
import * as React from 'react'

export default { P5MazeGame, React }